import React from "react";
import "./HorizontalComponent.css";
import StripTwo from "../../assets/images/horizontal.strip2.svg";

const SecondHorizontal = () => {
  return (
    <>
      <div className="image-container">
        <img src={StripTwo} alt="decorative strip" className="strip-image" />
      </div>
      <div className="horizontal-box">
        <div className="horizontal-content-box">
          <div className="big-number">2</div>
          <div className="horizontal-content">
            <div className="horizontal-content-title">{`Second`}</div>
            <div className="horizontal-content-text">
              {`The runner-up of Code++ takes away a cash-prize worth`}
              <b style={{ color: "#7F30FF" }}>{` Rs. 5000`}</b>
              {`. While it's not quite as prestigious as first prize, winning Code++'s second prize is still a great achievement.`}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SecondHorizontal;
